{
  "addons.addonList": "Tilläggslista",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Skapa och hämta din API-nyckel från den här länken",
  "addons.ambientWeatherDescription": "Ambient väderstationer (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API-nyckel",
  "addons.applicationKey": "Applikationsnyckel",
  "addons.connect": "Anslut",
  "addons.davisApiSecret": "Hemligt API",
  "addons.davisApiV2Key": "API-nyckel V2",
  "addons.davisDescription": "Davis väderstationer (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Hämta dina V2 API-nycklar från den här länken",
  "addons.disconnect": "Koppla från",
  "addons.ecowittCreateAndRetrieveKeys": "Skapa och hämta din API-nyckel och appnyckel från den här länken",
  "addons.ecowittDescription": "Ecowitt tillhandahåller professionella väderstationer, trådlösa inomhus- och utomhustermometrar, högprecisionsregnmätare, luftkvalitetssensorer och mycket mer.",
  "addons.helpLink": "Så här ansluter du {provider}",
  "addons.myAcuriteAccountOnHold": "Ditt konto har spärrats. Ange ditt lösenord för att återansluta ditt konto",
  "addons.myAcuriteDescription": "AcuRite är det #1 väderstationsvarumärket i Nordamerika. Som ledare inom tid-, temperatur- och väderteknologi ger AcuRite dig detaljerad information om din inomhus- och utomhusmiljö så att du kan planera din dag med tillförsikt.",
  "addons.myAcuriteEnterCredentials": "Ange dina My AcuRite-uppgifter för att länka ditt My AcuRite-konto till SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Använd din Netatmo-termostat för att ändra temperaturen i hemmet, från din säng eller från andra sidan världen.",
  "addons.netatmoThermostat": "Netatmo Thermostat",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Egna vädermätningar på din smartphone.",
  "addons.or": "eller",
  "addons.providerAccountDisconnected": "Anslutningen till din vädertjänst har löpt ut. Anslut igen för att återuppta datauppdateringar.",
  "addons.reconnect": "Återanslut",
  "addons.weatherflowCreateToken": "Skapa och hämta din token från den här länken",
  "addons.weatherflowTempestDescription": "Tempest väderstation utvecklad av Weatherflow",
  "addons.wundergroundApiKey": "API-nyckel",
  "addons.wundergroundDescription": "Weather Underground är en global gemenskap av människor som ansluter data från miljösensorer som väderstationer och luftkvalitetsmonitorer så att vi kan leverera den rika, hyperlokala informationen du behöver för att driva dina passioner.",
  "addons.wundergroundRetrieveApiKey": "Hämta din API-nyckel från den här länken",
  "addons.wundergroundRetrieveStationId": "Hämta din stationsidentifierare (ID) från denna länk",
  "addons.wundergroundStationId": "Stations-ID",
  "airQuality.airQuality": "Luftkvalitet",
  "airQuality.airQualityIndex": "Luftkvalitetsindex",
  "airQuality.aqiForecast": "Prognos för luftkvalitet",
  "airQuality.co": "Kolmonoxid",
  "airQuality.dailyForecast": "Daglig prognos",
  "airQuality.details": "Detaljer",
  "airQuality.dominantPollutant": "Dominerande förorening",
  "airQuality.good": "Bra",
  "airQuality.goodDescription": "Luftkvaliteten är tillfredsställande och risken för föroreningar anses lite eller obefintlig",
  "airQuality.hazardous": "Farlig",
  "airQuality.hazardousDescription": "Hälsovarning: Vem som helst kan uppleva allvarligare hälsoeffekter.",
  "airQuality.indoorAirQuality": "Luftkvalitet inomhus",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Måttlig",
  "airQuality.moderateDescription": "Luftkvaliteten är acceptabel. Men för vissa typer av föroreningar kan det finnas ett måttligt hälsoproblem för ett mycket litet antal människor som är överkänsliga för luftföroreningar.",
  "airQuality.no2": "Kvävedioxid",
  "airQuality.o3": "Ozon",
  "airQuality.pm10": "Partiklar med en diameter på 10 μm eller mindre",
  "airQuality.pm25": "Partiklar med en diameter på 2,5 μm eller mindre",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "Ohälsosamt för känsliga personer",
  "airQuality.sensitiveUnhealthyDescription": "Känsliga personer kan uppleva hälsoeffekter. De flesta kommer sannolikt inte att påverkas.",
  "airQuality.so2": "Svaveldioxid",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "Ohälsosamt",
  "airQuality.unhealthyDescription": "Alla kan uppleva hälsoeffekter; känsliga personer kan uppleva allvarligare hälsoeffekter",
  "airQuality.veryUnhealthy": "Mycket ohälsosamt",
  "airQuality.veryUnhealthyDezscription": "Varningar om nödsituationer. Det är sannolikt att hela befolkningen påverkas.",
  "alerts.addAlert": "Lägg till en varning",
  "alerts.addCondition": "Lägg till villkor",
  "alerts.alertAdded": "Varningen har lagts till",
  "alerts.alertAuthorizationNotice": "Varningar kan bara fungera om du tillåter SmartMixin att visa aviseringar",
  "alerts.alertDeleted": "Varningen har tagits bort",
  "alerts.alertEdited": "Varningen har ändrats",
  "alerts.alertName": "Varningsnamn",
  "alerts.alertWhen": "Jag vill bli varnad",
  "alerts.aqiGreaterThan": "AQI större än",
  "alerts.aqiGreaterThanThreshold": "AQI över tröskeln {value}{unit}",
  "alerts.aqiLessThan": "AQI mindre än",
  "alerts.aqiLessThanThreshold": "AQI under tröskelvärdet {value}{unit}",
  "alerts.atLeastOneCondition": "Du måste lägga till minst ett villkor",
  "alerts.co2GreaterThan": "CO2 större än",
  "alerts.co2GreaterThanThreshold": "CO2 över tröskelvärdet {value}{unit}",
  "alerts.co2LessThan": "CO2 mindre än",
  "alerts.co2LessThanThreshold": "CO2 under tröskelvärdet {value}{unit}",
  "alerts.conditions": "Villkor",
  "alerts.createAlert": "Skapa varning",
  "alerts.dailyPrecipitationGreaterThan": "Dygnsnederbörd större än",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Dygnsnederbörd över tröskelvärdet {value}{unit}",
  "alerts.deleteAlert": "Ta bort varning",
  "alerts.editAlert": "Redigera varning",
  "alerts.editCondition": "Ändra villkor",
  "alerts.gustSpeedGreaterThan": "Vindbyar större än",
  "alerts.gustSpeedGreaterThanThreshold": "Burst över tröskelvärdet {value}{unit}",
  "alerts.gustSpeedLessThan": "Vindbyg mindre än",
  "alerts.gustSpeedLessThanThreshold": "Burst under tröskelvärdet {value}{unit}",
  "alerts.heatIndexGreaterThan": "Värmeindex större än",
  "alerts.heatIndexGreaterThanThreshold": "Värmeindex över tröskelvärdet {value}{unit}",
  "alerts.heatIndexLessThan": "Värmeindex mindre än",
  "alerts.heatIndexLessThanThreshold": "Värmeindex under tröskelvärdet {value}{unit}",
  "alerts.humidexGreaterThan": "Fuktindex större än",
  "alerts.humidexGreaterThanThreshold": "Fuktindex över tröskelvärdet {value}{unit}",
  "alerts.humidexLessThan": "Fuktindex mindre än",
  "alerts.humidexLessThanThreshold": "Fuktindex under tröskelvärdet {value}{unit}",
  "alerts.humidityGreaterThan": "Luftfuktighet ovanför",
  "alerts.humidityGreaterThanThreshold": "Fuktighet över tröskelvärdet {value}{unit}",
  "alerts.humidityLessThan": "Fuktighet nedan",
  "alerts.humidityLessThanThreshold": "Fuktighet under tröskelvärdet {value}{unit}",
  "alerts.inProgress": "Pågående",
  "alerts.myAlerts": "Mina varningar",
  "alerts.noConfiguredAlert": "Du har ingen avisering än, lägg till en",
  "alerts.noiseGreaterThan": "Buller större än",
  "alerts.noiseGreaterThanThreshold": "Brus över tröskelvärdet {value}{unit}",
  "alerts.noiseLessThan": "Buller mindre än",
  "alerts.noiseLessThanThreshold": "Brus under tröskelvärdet {value}{unit}",
  "alerts.noteOnConditions": "Observera att varningen utlöses när alla villkor nedan är verifierade",
  "alerts.noTriggerHistory": "Det här larmet har inte utlösts ännu.",
  "alerts.pm10GreaterThan": "PM 10 större än",
  "alerts.pm10GreaterThanThreshold": "PM 10 över tröskeln {value}{unit}",
  "alerts.pm10LessThan": "PM 10 mindre än",
  "alerts.pm10LessThanThreshold": "PM 10 under tröskelvärdet {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 större än",
  "alerts.pm1GreaterThanThreshold": "PM 1 över tröskeln {value}{unit}",
  "alerts.pm1LessThan": "PM 1 mindre än",
  "alerts.pm1LessThanThreshold": "PM 1 under tröskelvärdet {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 större än",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 över tröskelvärdet {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 mindre än",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 under tröskelvärdet för {value}{unit}",
  "alerts.postStormSummary": "Sammanfattning efter regn",
  "alerts.postStormSynopsisHelper": "Du får en sammanfattande avisering varje gång regnet slutar.",
  "alerts.postStormSynopsisSoleCondition": "En sammanfattning efter storm kan inte kombineras med andra villkor.",
  "alerts.precipitationGreaterThan": "Timnederbörd större än",
  "alerts.precipitationGreaterThanThreshold": "Timnederbörd över tröskelvärdet {value}{unit}",
  "alerts.pressureGreaterThan": "Tryck större än",
  "alerts.pressureGreaterThanThreshold": "Tryck över tröskelvärdet {value}{unit}",
  "alerts.pressureLessThan": "Tryck mindre än",
  "alerts.pressureLessThanThreshold": "Tryck under tröskelvärdet {value}{unit}",
  "alerts.rainRateGreaterThan": "Regnintensitet större än",
  "alerts.rainRateGreaterThanThreshold": "Regnintensitet över tröskelvärdet {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Solinstrålning större än",
  "alerts.solarRadiationGreaterThanThreshold": "Solstrålning över tröskelvärdet {value}{unit}",
  "alerts.solarRadiationLessThan": "Solinstrålning mindre än",
  "alerts.solarRadiationLessThanThreshold": "Solstrålning under tröskelvärdet {value}{unit}",
  "alerts.stormChartUnavailable": "Regnhistorik för det här regnet är inte tillgänglig.",
  "alerts.stormDetail": "Sammanfattning av regn",
  "alerts.stormDuration": "Varaktighet",
  "alerts.stormEnd": "Slut",
  "alerts.stormPeakRate": "Maximal regnintensitet",
  "alerts.stormStart": "Start",
  "alerts.stormTotal": "Total nederbörd",
  "alerts.temperatureGreaterThan": "Temperatur över",
  "alerts.temperatureGreaterThanThreshold": "Temperatur över tröskelvärdet {value}{unit}",
  "alerts.temperatureLessThan": "Temperatur under",
  "alerts.temperatureLessThanThreshold": "Temperatur under tröskelvärdet {value}{unit}",
  "alerts.thswGreaterThan": "THSW större än",
  "alerts.thswGreaterThanThreshold": "THSW över tröskelvärdet {value}{unit}",
  "alerts.thswLessThan": "THSW mindre än",
  "alerts.thswLessThanThreshold": "THSW under tröskelvärdet {value}{unit}",
  "alerts.thwGreaterThan": "THW större än",
  "alerts.thwGreaterThanThreshold": "THW över tröskelvärdet {value}{unit}",
  "alerts.thwLessThan": "THW mindre än",
  "alerts.thwLessThanThreshold": "THW under tröskelvärdet {value}{unit}",
  "alerts.triggerHistory": "Larmhistorik",
  "alerts.uvGreaterThan": "UV högre än",
  "alerts.uvGreaterThanThreshold": "UV över tröskelvärdet {value}{unit}",
  "alerts.uvLessThan": "UV lägre än",
  "alerts.uvLessThanThreshold": "UV under tröskelvärdet {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Synlighet över tröskelvärdet {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Synlighet under tröskelvärdet {value}{unit}",
  "alerts.visiblityGreaterThan": "Sikt större än",
  "alerts.visiblityLessThan": "Sikt mindre än",
  "alerts.whichMeasure": "För vilket mätvärde skulle du vilja bli varnad?",
  "alerts.whichModule": "Vilken modul skulle du vilja bli varnad för?",
  "alerts.windChillGreaterThan": "Vindens kyleffekt större än",
  "alerts.windChillGreaterThanThreshold": "Vindens kyleffekt över tröskelvärdet {value}{unit}",
  "alerts.windChillLessThan": "Vindens kyleffekt mindre än",
  "alerts.windChillLessThanThreshold": "Vindens kyleffekt under tröskelvärdet {value}{unit}",
  "alerts.windSpeedGreaterThan": "Vinden större än",
  "alerts.windSpeedGreaterThanThreshold": "Vind över tröskelvärdet {value}{unit}",
  "alerts.windSpeedLessThan": "Vind mindre än",
  "alerts.windSpeedLessThanThreshold": "Vind under tröskelvärdet {value}{unit}",
  "astral.astronomicalSunPhase": "Astronomisk {sunPhase}",
  "astral.civilSunPhase": "Civil {sunPhase}",
  "astral.dawn": "Gryning",
  "astral.dusk": "Skymning",
  "astral.firstQuarter": "första kvarten",
  "astral.fullMoon": "Fullmåne",
  "astral.lastQuarter": "Sista kvartalet",
  "astral.moon": "Måne",
  "astral.moonPhases": "Månfaser",
  "astral.moonrise": "Månuppgång",
  "astral.moonset": "Månnedgång",
  "astral.nauticalSunPhase": "Nautisk {sunPhase}",
  "astral.newMoon": "Ny måne",
  "astral.noon": "Middagstid",
  "astral.remainingDaylight": "Återstående dagsljus",
  "astral.sunrise": "Soluppgång",
  "astral.sunriseAndSunset": "Soluppgång och solnedgång",
  "astral.sunriseAt": "Soluppgång kl. {time}",
  "astral.sunset": "Solnedgång",
  "astral.sunsetAt": "Solnedgång kl. {time}",
  "astral.totalDaylight": "Totalt dagsljus",
  "astral.waningCrescent": "Sista halvmånen",
  "astral.waningGibbous": "Avtagande gibbous måne",
  "astral.waxingCrescent": "Första halvmånen",
  "astral.waxingGibbous": "Vaxande måne",
  "auth.alreadyHaveAccount": "Har du redan ett konto?",
  "auth.authContainerTagline": "Din personliga väderpanel. Anslut dina stationer och få realtidsdata inom räckhåll.",
  "auth.backToLogin": "Tillbaka till inloggning",
  "auth.catchPhrase": "Den intelligenta väderplattformen",
  "auth.checkYourEmail": "Kontrollera din e-post",
  "auth.continueWithApple": "Fortsätt med Apple",
  "auth.continueWithFacebook": "Fortsätt med Facebook",
  "auth.continueWithGoogle": "Fortsätt med Google",
  "auth.email": "E-postadress",
  "auth.emailRequiredLoginFacebook": "E-postbehörighet krävs för att ansluta med Facebook",
  "auth.emailVerification": "Mejl verifikation",
  "auth.emailVerificationFailure": "Ett problem har uppstått med din e-postverifikation",
  "auth.emailVerificationSuccess": "Din e-postadress har blivit verifierad",
  "auth.firstName": "Förnamn",
  "auth.forgotPassword": "Glömt lösenord?",
  "auth.forgotPasswordSubtitle": "Ange din e-postadress så skickar vi en länk för att återställa ditt lösenord.",
  "auth.lastName": "Efternamn",
  "auth.login": "Logga in",
  "auth.loginSubtitle": "Välkommen tillbaka! Vänligen ange dina uppgifter.",
  "auth.loginToSmartMixinDescription": "Ange dina SmartMixin-uppgifter för att komma åt ditt konto.",
  "auth.logout": "Logga ut",
  "auth.logoutConfirmation": "Är du säker på att du vill koppla från?",
  "auth.noAccountYet": "Har du inget konto ännu?",
  "auth.or": "eller",
  "auth.password": "Lösenord",
  "auth.passwordAgain": "Ange lösenord igen",
  "auth.passwordReset": "Lösenord återställt",
  "auth.passwordResetSuccess": "Ditt lösenord har uppdaterats",
  "auth.register": "Skapa konto",
  "auth.registerDescription": "Skapa ett gratis SmartMixin-konto för att ansluta dina väderstationer, följa väderdata och få tillgång till kraftfulla analysverktyg.",
  "auth.registerSubtitle": "Skapa ditt konto för att komma igång.",
  "auth.registerSuccess": "Du har registrerat dig! Vi har skickat en verifieringslänk till {emailAddress} med ytterligare instruktioner.",
  "auth.restorePassword": "Återställ lösenord",
  "auth.restorePasswordSuccess": "Vi har skickat en länk till återställning av lösenord till {emailAddress} med ytterligare instruktioner.",
  "auth.sendReset": "Skicka återställningsinstruktioner",
  "auth.signInWithApple": "",
  "auth.socialAccount": "eller använd ditt konto",
  "auth.welcome": "Välkommen till SmartMixin",
  "auth.welcomeBack": "Välkommen tillbaka!",
  "calendar.april": "April",
  "calendar.august": "Augusti",
  "calendar.dateFormat": "datumformat",
  "calendar.day": "Dag",
  "calendar.december": "December",
  "calendar.end": "Avsluta",
  "calendar.february": "Februari",
  "calendar.hours": "timmar",
  "calendar.hoursShort": "tim",
  "calendar.january": "Januari",
  "calendar.july": "Juli",
  "calendar.june": "Juni",
  "calendar.last24Hours": "senaste 24 timmarna",
  "calendar.last30Days": "senaste 30 dagarna",
  "calendar.last7Days": "senaste 7 dagarna",
  "calendar.march": "Mars",
  "calendar.max": "Max",
  "calendar.may": "Maj",
  "calendar.month": "Månad",
  "calendar.months": "månader",
  "calendar.november": "November",
  "calendar.october": "Oktober",
  "calendar.oneDay": "1 dag",
  "calendar.oneHour": "1 timme",
  "calendar.oneMonth": "1 månad",
  "calendar.oneWeek": "1 vecka",
  "calendar.previous24Hours": "De senaste 24 timmarna",
  "calendar.previous30Days": "De senaste 30 dagarna",
  "calendar.previous7Days": "De senaste 7 dagarna",
  "calendar.previousDay": "Föregående dag",
  "calendar.previousMonth": "Föregående månad",
  "calendar.previousWeek": "Föregående vecka",
  "calendar.previousYear": "Föregående år",
  "calendar.sameDayLastYear": "Samma dag föregående år",
  "calendar.sameMonthLastYear": "Samma månad föregående år",
  "calendar.selectADate": "Välj ett datum",
  "calendar.selectAggregation": "Välj visat värde",
  "calendar.selectAMonth": "Välj en månad",
  "calendar.selectAYear": "Välj ett år",
  "calendar.selectGranularity": "Välj en upplösning",
  "calendar.selectTimescale": "Välj en tidsskala",
  "calendar.september": "September",
  "calendar.sixHours": "6 timmar",
  "calendar.start": "Början",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 timmar",
  "calendar.use24HourFormat": "Använd 24-timmarsformat",
  "calendar.week": "Vecka",
  "calendar.year": "År",
  "calendar.yesterday": "I går",
  "common.accountDeleted": "Ditt konto har raderats.",
  "common.accountOnHold": "Din kontoanslutning har löpt ut. Anslut igen för att återuppta datauppdateringar.",
  "common.add": "Lägg till",
  "common.addAStation": "Lägg till station",
  "common.addToFavorites": "Lägg till i Favoriter",
  "common.addYourOwnStation": "Lägg till din egen station",
  "common.alreadyPremium": "Du har redan ett premiumkonto!",
  "common.alsoAvailableOn": "Finns även på:",
  "common.altitude": "Altitud",
  "common.analysis": "Analys",
  "common.aroundMe": "Omkring mig",
  "common.articleCount": "{count, plural, one {# artikel} other {# artiklar}}",
  "common.articleNotFound": "Artikeln hittades inte",
  "common.articleNotFoundDescription": "Artikeln du letar efter finns inte.",
  "common.average": "Genomsnitt",
  "common.averageOverThePeriod": "Genomsnitt under perioden",
  "common.away": "Borta",
  "common.back": "Tillbaka",
  "common.backToHelpCenter": "Tillbaka till hjälpcentret",
  "common.backToHome": "Tillbaka till Startsidan",
  "common.bad": "Dåligt",
  "common.batteryLevel": "Batterinivå",
  "common.bestValue": "Bästa Värde",
  "common.billingDetailsAndroid": "För en kostnadsfri testversion kommer du inte att debiteras om du avbryter 24 timmar innan den kostnadsfria introduktionsperioden löper ut. När testperioden är över kan du när som helst säga upp SmartMixin-prenumerationen via Google Play eller så kommer att automatiskt förnyas. Detta måste göras 24 timmar före prenumerationsperiodens slut för att undvika att debiteras ytterligare en avgift som visas i knappen ovan. Prenumerationsbetalningar debiteras ditt Google Play-konto vid bekräftelse på ditt köp och när varje förnyelseperiod påbörjas.",
  "common.billingDetailsIos": "För en kostnadsfri testversion kommer du inte att debiteras om du avbryter 24 timmar innan den kostnadsfria introduktionsperioden löper ut. När testperioden är över kan du när som helst säga upp SmartMixin-prenumerationen via din App-butik eller så kommer att automatiskt förnyas. Detta måste göras 24 timmar före prenumerationsperiodens slut för att undvika att debiteras ytterligare en avgift som visas i knappen ovan. Prenumerationsbetalningar debiteras ditt App Store-konto vid bekräftelse på ditt köp och när varje förnyelseperiod påbörjas.",
  "common.boilerOn": "Värme på",
  "common.browseByCategory": "Bläddra efter kategori",
  "common.calendarView": "Kalendervy",
  "common.cancel": "Avbryt",
  "common.cannotBeEmpty": "Det här fältet får inte vara tomt.",
  "common.cardDetails": "Kortdetaljer",
  "common.categoryNotFound": "Kategori hittades inte",
  "common.categoryNotFoundDescription": "Denna kategori finns inte eller har inga artiklar.",
  "common.charts": "Diagram",
  "common.chartView": "Diagramvy",
  "common.clearRecentLocations": "Rensar alla",
  "common.close": "Stäng",
  "common.comparison": "Jämförelse",
  "common.contactMe": "Kontakta mig",
  "common.currentDay": "I dag",
  "common.currentLocation": "Nuvarande plats",
  "common.currentObservations": "Nuvarande observationer",
  "common.currentRainEvent": "Aktuell regnhändelse",
  "common.currentRate": "Regnintensitet",
  "common.currentWeatherConditions": "Nuvarande villkor",
  "common.customizeComparisonMetrics": "Anpassa mätvärden",
  "common.customizeComparisonMetricsDescription": "Dra objekt för att ordna om dina jämförelsemått. Tryck på ögonikonen för att visa eller dölja mätvärden.",
  "common.customizeDashboard": "Anpassa",
  "common.customizeDashboardDescription": "Dra objekt för att ändra ordningen på din instrumentpanel. Tryck på ögonsymbolen för att visa eller dölja sektioner.",
  "common.customizedStationName": "Anpassat stationsnamn",
  "common.dailyForecast": "Daglig prognos",
  "common.dashboard": "Start",
  "common.default": "Standard",
  "common.defaultForecastModelChip": "Standard · {name}",
  "common.delete": "Radera",
  "common.deleteAccount": "Radera konto",
  "common.deleteAccountConfirmation": "Är du säker på att du vill ta bort ditt konto? Denna åtgärd är oåterkallelig.",
  "common.deleteAccountDescription": "Denna åtgärd raderar ditt konto och all din information. Det finns ingen väg tillbaka.",
  "common.details": "Detaljer",
  "common.edit": "Redigera",
  "common.editor": "Redigerare",
  "common.endTime": "Slutet",
  "common.exitFullscreen": "Avsluta helskärm",
  "common.exploreWeatherMap": "Utforska Väderkartan",
  "common.favoriteLocations": "Favoriter",
  "common.favoriteLocationsEmpty": "Du kan lägga till upp till 5 favoritplatser.",
  "common.favoriteStations": "Favoritstationer",
  "common.feedbackHelpsImprove": "Din feedback hjälper oss att förbättra våra hjälpartiklar.",
  "common.feedbackReasonNotAnswer": "Den besvarar inte min fråga",
  "common.feedbackReasonOutdated": "Informationen är föråldrad",
  "common.feedbackReasonUnclear": "Instruktionerna är otydliga",
  "common.feedbackWhatWentWrong": "Vad var problemet?",
  "common.filterStationDescription": "Visa inte stationer med opålitliga data",
  "common.filterStations": "Filtrera stationer",
  "common.filterStationSourceDescription": "Välj stationsleverantörer som du vill visa på kartan",
  "common.findStationsNearYou": "Hitta stationer nära dig",
  "common.firmwareVersion": "Firmware-version",
  "common.forecast": "Prognos",
  "common.forecastComparisonDescription": "Jämför enkelt data från olika tillgängliga vädermodeller",
  "common.forecastModelComparison": "Jämförelse av vädermodeller",
  "common.forecastModelCoverage": "Täckning",
  "common.forecastModelDescription": "Beskrivning",
  "common.forecastModelDescription_AROME": "Météo Frances konvektionsupplösande högupplösningsmodell över Västeuropa med 1,3 km upplösning. Bäst i klassen för korttidsprognoser i Frankrike; uppdateras var tredje timme.",
  "common.forecastModelDescription_ARPEGE_EU": "Météo Frances europeiska bo av ARPEGE-modellen med 10 km upplösning. Medellånga prognoser över Europa, uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Météo Frances globala numeriska väderprognosmodell med 25 km upplösning, som körs upp till cirka 4 dagar. Uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_DMI_DINI": "DMI:s HARMONIE DINI: en konvektionsupplösande modell över nordvästra Europa — Danmark, Benelux, Irland, Storbritannien och Skandinavien — med 2 km upplösning som körs upp till 60 timmar, uppdateras åtta gånger om dagen. Innehåller modifierade öppna data från DMI (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Environment Canadas Global Deterministic Prediction System: en världsomspännande medellång modell med 15 km upplösning som körs upp till 10 dagar, uppdateras två gånger om dagen.",
  "common.forecastModelDescription_EC_HRDPS": "Environment Canadas High Resolution Deterministic Prediction System: en konvektionsupplösande modell över Kanada och norra USA med 2,5 km upplösning som körs upp till 48 timmar, uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_EC_RDPS": "Environment Canadas Regional Deterministic Prediction System: en medellång modell över Nordamerika med 10 km upplösning, uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_ECMWF_HRES": "Det europeiska centret för medellånga väderprognosers flaggskeppsmodell med hög upplösning (IFS), allmänt betraktad som världens ledande globala prognossystem. Täcker hela planeten med 25 km upplösning upp till 15 dagar, uppdateras fyra gånger dagligen. Innehåller modifierade öppna data från ECMWF (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "NOAAs flaggskepps medellånga globala modell. Täcker hela planeten med 25 km upplösning upp till 16 dagar, uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_HRRR_CONUS": "NOAAs High-Resolution Rapid Refresh: en konvektionsupplösande modell över kontinentala USA med 3 km upplösning, uppdateras varje timme. Bäst lämpad för mycket korttidsprognoser av åskväder och svårt väder.",
  "common.forecastModelDescription_ICON": "DWD:s globala ICON-modell med 13 km upplösning som täcker hela planeten upp till 7,5 dagar, uppdateras fyra gånger om dagen. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ItaliaMeteos ICON-2I, som drivs tillsammans med ARPAE: en konvektionsupplösande modell över Italien med 2,2 km upplösning som körs upp till 72 timmar, uppdateras två gånger om dagen. Innehåller öppna data från ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "MeteoSwiss ICON-CH1-EPS-kontrollkörning: en konvektionsupplösande modell över Alperna med 1 km upplösning som körs upp till 33 timmar, uppdateras var tredje timme.",
  "common.forecastModelDescription_ICON_CH2": "MeteoSwiss ICON-CH2-EPS-kontrollkörning: en konvektionsupplösande modell över Alperna — Schweiz och den omgivande alpregionen — med 2,1 km upplösning som körs upp till 120 timmar, uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_ICON_DE": "DWDs högupplösta konvektionsupplösande modell över Tyskland och kringliggande länder med 2,2 km upplösning. Korttidsprognoser uppdateras två gånger om dagen. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "DWDs europeiska bo av ICON-modellen med 7 km upplösning som täcker Europa och Nordatlanten. Medellånga prognoser uppdateras fyra gånger om dagen. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Norska meteorologiska institutets öppna väderprognostjänst, som kombinerar högupplösta nordiska modeller med ECMWF-data för att ge världsomspännande prognoser upp till 10 dagar framåt.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "AROME-bo över de franska Antillerna (Guadeloupe, Martinique) med 2,5 km upplösning. Korttidsprognoser uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "AROME-bo över Franska Guyana med 2,5 km upplösning. Korttidsprognoser uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "AROME-bo över Nya Kaledonien med 2,5 km upplösning. Korttidsprognoser uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "AROME-bo över Franska Polynesien med 2,5 km upplösning. Korttidsprognoser uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "AROME-bo över Réunion och Mayotte med 2,5 km upplösning. Korttidsprognoser uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_NAM_CONUS": "NOAAs North American Mesoscale modellbo över kontinentala USA med 5 km upplösning. Korttidsprognoser uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "NOAAs North American Mesoscale modell som täcker hela Nordamerika med 32 km upplösning. Uppdateras fyra gånger om dagen.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "SmartMixins flaggskeppsprognos. För varje timme på din plats väljer vi den bästa tillgängliga modellen — vanligtvis en högupplöst regional modell där det finns en (AROME i Frankrike, ICON-D2 i Tyskland, HRRR i USA, ARPEGE Europe över hela kontinenten…) och vi faller tillbaka på en global modell på andra ställen — sedan fyller vi i eventuella luckor från grannkällor. Resultatet är en enda sömlös prognos som täcker var som helst i världen upp till 14 dagar, automatiskt uppdaterad varje gång någon av de underliggande modellerna uppdateras.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Weatherflows egenutvecklade globala prognos som kombinerar flera numeriska vädermodeller med observationer från dess Tempest-väderstationsnätverk. 10-dagars världsomspännande horisont.",
  "common.forecastModelDetailTitle": "Prognosmodell",
  "common.forecastModelScopeGlobal": "Global",
  "common.forecastModelScopeGlobalDescription": "Denna modell täcker hela planeten.",
  "common.forecastModelScopeRegional": "Regional",
  "common.forecastModelScopeRegionalDescription": "Denna modell täcker endast en specifik region.",
  "common.forecastModelSpecifications": "Specifikationer",
  "common.forecastSources": "Prognoskällor",
  "common.freeAccount": "Gratis konto",
  "common.freeSubscription": "Gratis prenumeration",
  "common.freeTrialForPeriod": "Gratis provperiod under {period} dagar",
  "common.frequency": "Frekvens",
  "common.full": "Full",
  "common.fullscreen": "Helskärm",
  "common.getStartedFree": "Börja Gratis",
  "common.getUnlimitedAccess": "Obegränsad tillgång till:",
  "common.good": "Bra",
  "common.hail": "Hagel",
  "common.help": "Hjälp",
  "common.helpCategoryAccount": "Konto",
  "common.helpCategoryBilling": "Fakturering",
  "common.helpCategoryGettingStarted": "Kom igång",
  "common.helpCategoryProviders": "Leverantörer",
  "common.helpCategoryStations": "Stationer",
  "common.helpCategoryTroubleshooting": "Felsökning",
  "common.helpCenter": "Hjälpcenter",
  "common.helpCenterDescription": "Hitta svar på vanliga frågor och lär dig hur du får ut det mesta av SmartMixin.",
  "common.hg": "Frostvakt",
  "common.hidden": "Dolda",
  "common.hiddenSensors": "Dolda sensorer",
  "common.hiddenStations": "Dolda stationer",
  "common.hiddenStationsDescription": "Du kan dölja en station genom att knacka på ögonikonen bredvid den.",
  "common.high": "Hög",
  "common.home": "Hem",
  "common.homeConnectService": "Äger du en väderstation? Anslut din tjänst",
  "common.homeInformation": "Heminformation",
  "common.homeIntroduction": "Börja ansluta dina externa konton för att använda SmartMixin-funktioner.",
  "common.homeName": "Hemmets namn",
  "common.homeSubtitle": "Ditt väder, allt på ett ställe",
  "common.horizon": "Horisont",
  "common.horizonValue": "upp till {value} timmar",
  "common.iDontKnowYet": "Jag vet inte ännu",
  "common.indoor": "Inomhus",
  "common.lastRainEvent": "Sista regnhändelsen",
  "common.lastUpdate": "Senaste uppdatering",
  "common.legendHeavy": "Kraftig",
  "common.legendLight": "Lätt",
  "common.legendLightningHelp": "Färgen visar varje blixtnedslags ålder under de senaste {minutes} minuterna — de nyaste i vitt, de äldsta i mörkrött.",
  "common.legendNewest": "Nyaste",
  "common.legendOldest": "Äldsta",
  "common.legendStationsHelp": "Markörens färg återspeglar värdet på det valda måttet.",
  "common.lightningDataAttribution": "Blixtdata: Blitzortung.org",
  "common.lightningStrikes": "Blixtnedslag",
  "common.lightningStrikesDescription": "Visa blixtnedslag i realtid på kartan",
  "common.linkToSection": "Länk till det här avsnittet",
  "common.loading": "Laddar",
  "common.location": "Plats",
  "common.locationAddedToFavorites": "Plats tillagd till favoriter",
  "common.locationNotGranted": "Platstillstånd beviljas inte. Tillåt åtkomst till din plats i enhetsinställningar.",
  "common.locationRemovedFromFavorites": "Plats bort från favoriter",
  "common.locations": "Platser",
  "common.low": "Låg",
  "common.manage": "Hantera",
  "common.manageAccount": "Hantera konto",
  "common.manageMySubscription": "Hantera min prenumeration",
  "common.manageSensors": "Hantera sensorer",
  "common.manageSensorsDescription": "Dra objekt för att ändra ordningen på sensorer. Tryck på ögonsymbolen för att visa eller dölja sensorer. Tryck på ett namn för att byta namn.",
  "common.manualBoost": "Manuell boost",
  "common.manualSetpointUntil": "Manuellt börvärde till",
  "common.mapLayers": "Kartlager",
  "common.mapLegend": "Kartteckenförklaring",
  "common.maxFavoriteLocationsReached": "Du kan bara ha upp till 5 favoritplatser. Ta bort en för att lägga till en annan.",
  "common.maximum": "Maximum",
  "common.measureToDisplay": "Mätvärde att visa",
  "common.medium": "Medel",
  "common.meshSize": "Rasterstorlek",
  "common.minimum": "Minimum",
  "common.minRead": "{minutes} min läsning",
  "common.modifyFavoriteStations": "Ändra favoritstationer",
  "common.modifyFavoriteStationsDescription": "Du kan ordna om dina favoritstationer genom att dra dem. Du kan också ta bort dem från listan.",
  "common.moduleType": "Modultyp",
  "common.monthTotal": "Månadssumma",
  "common.more": "Mer",
  "common.moreInformation": "Mer information",
  "common.myLocation": "Min plats",
  "common.nearbyWeatherStations": "Närliggande väderstationer",
  "common.next": "Nästa",
  "common.nextHours": "Följande timmar",
  "common.no": "Nej",
  "common.noAccountNeeded": "Inget konto krävs",
  "common.noDataForThisPeriod": "Ingen data för denna period",
  "common.noLocationsFound": "Inga platser hittades",
  "common.noNetatmoWeatherStationYet": "Du har inte Netatmo väderstation",
  "common.noOutdoorModule": "Det finns ingen fungerande utomhusmodul för denna station.",
  "common.noSearchResults": "Inga artiklar matchar din sökning",
  "common.noStationsFound": "Inga stationer hittades",
  "common.noThermostatYet": "Du har inte Netatmo termostat",
  "common.notNow": "Inte nu",
  "common.notPurchasedYet": "Det ser ut som att du inte har köpt pro-versionen ännu",
  "common.noWeatherStation": "Ingen väderstation",
  "common.noWeatherStationYet": "Du har inte väderstation",
  "common.numberOfActiveWarnings": "{warning_count} aktiva vädervarningar",
  "common.onThisPage": "På den här sidan",
  "common.openSettings": "Öppna inställningar",
  "common.orChooseMonthly": "Eller välj månadsvis:",
  "common.outdatedModule": "Data för den här modulen är inaktuella.",
  "common.outdoor": "Utomhus",
  "common.outdoorTemperature": "Utetemperatur",
  "common.pageNotFound": "Sidan Hittades Inte",
  "common.pageNotFoundDescription": "Sidan du letar efter finns inte eller har flyttats.",
  "common.passwordUpdated": "Lösenord har uppdaterats.",
  "common.personalWeatherIntelligence": "Din Personliga Väderintelligens",
  "common.platformMobileApp": "Mobilapp",
  "common.platformMobileOnly": "Endast i mobilappen",
  "common.platformWebApp": "Webbapp",
  "common.platformWebOnly": "Endast i webbappen",
  "common.popularArticles": "Populära artiklar",
  "common.premiumAccount": "Premiumkonto",
  "common.premiumDescription": "Premiumprenumeration låser upp ett stort antal ytterligare funktioner som avancerad väderanalys, diagramjämförelse, regionala prognosmodeller och mycket mer.",
  "common.premiumFeatureAlerts": "Vädervarningar",
  "common.premiumFeatureAnalysis": "Avancerad Väderanalys",
  "common.premiumFeatureCharts": "Diagramjämförelser",
  "common.premiumFeatureExport": "Dataexport",
  "common.premiumFeatureForecast": "Regionala Prognosmodeller",
  "common.premiumFeatureNotification": "Statusfältswidget",
  "common.premiumFeatureTitle": "Premiumfunktion",
  "common.premiumFeatureWidgets": "Hemskärmswidgetar",
  "common.pressureSummary": "Syntes av tryck",
  "common.previous": "Tidigare",
  "common.previousHours": "Tidigare timmar",
  "common.profileUpdated": "Profilen har uppdaterats.",
  "common.purchasedNetatmoPro": "Du har tidigare köpt Netatmo Pro ({date}). Prenumerera på ett av erbjudandena nedan för att få tillgång till alla premiumfunktioner i applikationen.",
  "common.radarDataAttribution": "Radardata: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Nederbörd",
  "common.rainEvents": "Regnhändelser",
  "common.rainfallMeasurement": "Regnmätning",
  "common.rainRadar": "Regnradar",
  "common.rainRadarDescription": "Visa regnradaröverlägg på kartan",
  "common.rainSummary": "Sammanfattning av nederbörd",
  "common.range": "Omfång",
  "common.recentLocations": "Ny",
  "common.recentLocationsEmpty": "Din senaste historia är tom.",
  "common.recentStations": "Nyliga stationer",
  "common.relatedArticles": "Relaterade artiklar",
  "common.relay": "Relä",
  "common.removeFromFavorites": "Ta bort från favoriter",
  "common.renameSensors": "Byta namn på sensorer",
  "common.resetZoom": "Återställ zoom",
  "common.restorePurchase": "Återställ köpet",
  "common.room": "Rum",
  "common.rooms": "Rum",
  "common.savingsPercent": "Spara {percent}%",
  "common.searchArticles": "Sök artiklar...",
  "common.searchForALocation": "Sök efter en plats...",
  "common.searchForLocation": "Sök plats",
  "common.searchForWeatherStation": "Sök en väderstation",
  "common.searchResults": "Sökresultat",
  "common.searchResultsEmpty": "Inga resultat hittades.",
  "common.searchResultsFound": "{count, plural, one {# resultat hittades} other {# resultat hittades}}",
  "common.searchStationsDescription": "Ange en stad, adress eller platsnamn för att hitta väderstationer i närheten.",
  "common.searchStationsHint": "Använd sökfältet ovan för att upptäcka väderstationer var som helst i världen.",
  "common.selectStationForComparison": "Välj station för jämförelse",
  "common.selectWeatherForecastProvider": "Välj en väderleverantör",
  "common.serialNumber": "Serienummer",
  "common.share": "Dela",
  "common.shareOutdoorMeasures": "Dela dina utomhusdata",
  "common.shareOutdoorMeasuresDescription": "Delta i SmartMixin-communityn genom att göra dina utomhusdata synliga för andra. Inomhusdata kommer aldrig att delas.",
  "common.shareYourWeather": "Dela ditt väder",
  "common.signalStrength": "Signalstyrka",
  "common.skip": "Hoppa",
  "common.smartThermostat": "Smart termostat",
  "common.smartValve": "Smart ventil",
  "common.snow": "Snö",
  "common.start": "Start",
  "common.startFreeTrial": "Starta Gratis Provperiod",
  "common.startTime": "Början",
  "common.station": "station",
  "common.stationAddedToFavorites": "Station tillagd till favoriter",
  "common.stationComparison": "Stationsjämförelse",
  "common.stationComparisonDescription": "Låter dig jämföra historisk väderdata med den för en annan station.",
  "common.stationInformation": "Stationsinformation",
  "common.stationName": "Stationens namn",
  "common.stationObservationsDescription": "Visa de senaste observationerna från väderstationer",
  "common.stationRemovedFromFavorites": "Stationen borttagen från favoriter",
  "common.stations": "stationer",
  "common.stationsNear": "Stationer nära",
  "common.stationType": "stationstyp",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Föråldrad",
  "common.statusSyncing": "Synkroniserar",
  "common.stillNeedHelp": "Behöver du fortfarande hjälp?",
  "common.stillNeedHelpDescription": "Om den här artikeln inte besvarade din fråga hjälper jag dig gärna direkt.",
  "common.subscribeNow": "Prenumerera nu - utan provperiod",
  "common.sumOverThePeriod": "Ackumulerat under perioden",
  "common.switchToPremium": "Byt till SmartMixin Premium",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Temperatur sammanfattning",
  "common.thankYouForFeedback": "Tack för din feedback!",
  "common.thenPrice": "sedan {price}",
  "common.timeSelection": "Periodval",
  "common.timezone": "Tidszon",
  "common.totalDuration": "Total varaktighet",
  "common.tryAnotherLocation": "Vi kunde inte hitta några väderstationer nära denna plats. Försök söka i ett annat område.",
  "common.unknown": "Okänd",
  "common.untilChanged": "Till ändrad",
  "common.untilTime": "Fram till {time}",
  "common.updateAvailable": "Uppdatering tillgänglig",
  "common.updateAvailableOpenAppStore": "Tryck för att öppna App Store",
  "common.updateAvailableOpenGooglePlay": "Tryck för att öppna Google Play",
  "common.updateAvailableVersion": "Uppdatering tillgänglig: v{version}",
  "common.upgrade": "Uppgradera",
  "common.upgradeRequiredAndroid": "En uppgradering av din app krävs, gå till Google Play för att uppgradera.",
  "common.upgradeRequiredIos": "En uppgradering av din app krävs, gå till app-butiken för att uppgradera.",
  "common.validate": "Bekräfta",
  "common.validEmail": "En giltig e-postadress krävs.",
  "common.very_low": "Mycket låg",
  "common.visitNetatmoWebsite": "Besök Netatmo Websida",
  "common.wasArticleHelpful": "Var denna artikel till hjälp?",
  "common.weatherCondition": "Väderförhållanden",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain är en extra datakälla som tillhandahålls via Tempest Weather System, som drivs av Nearcast Technology. NC Rain är en uppskattning av den genomsnittliga nederbördsackumuleringen runt din Tempest på grannskapsnivå",
  "common.weatherForecastModels": "Väderprognosmodeller",
  "common.weatherIntelligencePlatform": "Väderintelligensplattformen",
  "common.weatherMap": "Väderkarta",
  "common.weatherMapMetaDescription": "SmartMixin erbjuder interaktiva väder- och radarkartor för väderförhållanden världen över.",
  "common.weatherObservations": "Väderobservationer",
  "common.weatherStation": "Väderstation",
  "common.weatherStations": "Väderstationer",
  "common.welcome": "Välkommen till SmartMixin!",
  "common.whenBackHome": "När kommer du hem?",
  "common.wifiStrength": "WiFi-signalstyrka",
  "common.wind": "Vind",
  "common.windMeasurement": "Vindmätning",
  "common.windSpeed": "Vindhastighet",
  "common.windSummary": "Syntes av vinden",
  "common.yearToDate": "Det här året",
  "common.yes": "Ja",
  "common.zoomImage": "Förstora bilden",
  "forecastMaps.addColor": "Lägg till färg",
  "forecastMaps.addLayer": "Lägg till lager",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Tillbaka till kartorna",
  "forecastMaps.browseMaps": "Bläddra bland kartor",
  "forecastMaps.build": "Generera",
  "forecastMaps.buildCompleted": "Generering klar",
  "forecastMaps.builderMetaDescription": "Sätt ihop egna prognoskartor av vädermodellernas lager.",
  "forecastMaps.builderTitle": "Kartbyggare",
  "forecastMaps.buildFailed": "Genereringen misslyckades. Försök igen.",
  "forecastMaps.buildNotPossible": "Den här kartan kan inte genereras ännu — inga prognosdata är tillgängliga.",
  "forecastMaps.buildProgress": "Renderar… {completed}/{total} steg",
  "forecastMaps.buildStarting": "Startar generering…",
  "forecastMaps.byModel": "Efter modell",
  "forecastMaps.byZone": "Efter zon",
  "forecastMaps.colormap": "Färgskala",
  "forecastMaps.colormapCustom": "Anpassade färger",
  "forecastMaps.colormapGroupDomain": "Väderförval",
  "forecastMaps.colormapGroupMatplotlib": "Vetenskapliga förval",
  "forecastMaps.colorScale": "Färgskala",
  "forecastMaps.comingSoon": "Den här vyn kommer snart.",
  "forecastMaps.contourLevels": "Konturnivåer",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Frankrike",
  "forecastMaps.countryGermany": "Tyskland",
  "forecastMaps.countryItaly": "Italien",
  "forecastMaps.countryScandinavia": "Skandinavien",
  "forecastMaps.countrySpain": "Spanien",
  "forecastMaps.countrySwitzerland": "Schweiz",
  "forecastMaps.countryUnitedStates": "USA",
  "forecastMaps.customColormapMinColors": "En anpassad färgskala kräver minst två färger",
  "forecastMaps.customExtent": "Anpassat område",
  "forecastMaps.deleteMap": "Ta bort karta",
  "forecastMaps.deleteMapBody": "”{name}” och dess renderingar tas bort permanent.",
  "forecastMaps.deleteMapTitle": "Ta bort den här kartan?",
  "forecastMaps.displayName": "Visningsnamn",
  "forecastMaps.downloadMp4": "Ladda ner MP4",
  "forecastMaps.downscaling": "Gallringsfaktor för vindpilar",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Rita område",
  "forecastMaps.east": "Öst",
  "forecastMaps.editMap": "Redigera karta",
  "forecastMaps.exportBuilding": "Förbereder video…",
  "forecastMaps.exportError": "Videoexporten misslyckades. Försök igen.",
  "forecastMaps.exportMp4": "Exportera MP4",
  "forecastMaps.exportNotReady": "Videon är inte klar än. Försök igen senare.",
  "forecastMaps.extentDrawHint": "Dra på kartan för att rita området",
  "forecastMaps.extentInvalid": "Väst måste vara mindre än öst och syd mindre än nord",
  "forecastMaps.extentPanZoomHint": "Panorera och zooma tills området fyller ramen",
  "forecastMaps.flipbookView": "Animation",
  "forecastMaps.forecastModel": "Prognosmodell",
  "forecastMaps.forkAndEdit": "Duplicera och redigera",
  "forecastMaps.height": "Höjd (tum)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.invalidHexColor": "Ogiltig färg — använd #RRGGBB",
  "forecastMaps.layers": "Lager",
  "forecastMaps.layerTypeBarbs": "Vindpilar",
  "forecastMaps.layerTypeContour": "Konturlinjer",
  "forecastMaps.layerTypeFilledContour": "Fyllda konturer",
  "forecastMaps.layerTypeMagnitude": "Magnitud",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Vektorfält",
  "forecastMaps.leave": "Lämna",
  "forecastMaps.levelsCount": "Antal",
  "forecastMaps.levelsInvalid": "Ogiltiga konturnivåer",
  "forecastMaps.levelsModeArange": "Fast steg",
  "forecastMaps.levelsModeExplicit": "Explicita värden",
  "forecastMaps.levelsModeLinspace": "Jämnt fördelade (antal)",
  "forecastMaps.levelsStep": "Steg",
  "forecastMaps.levelsValues": "Värden",
  "forecastMaps.levelsValuesHint": "Kommaseparerade, stigande",
  "forecastMaps.localTimeHint": "Visas i din lokala tid",
  "forecastMaps.map": "Karta",
  "forecastMaps.mapDescription": "Beskrivning",
  "forecastMaps.mapName": "Kartnamn",
  "forecastMaps.mapNameRequired": "Ange ett namn",
  "forecastMaps.mapSettings": "Kartinställningar",
  "forecastMaps.mapView": "Interaktiv karta",
  "forecastMaps.maxLayersReached": "Den här kartan har nått maxantalet {max} lager.",
  "forecastMaps.maxValue": "Maxvärde",
  "forecastMaps.memoryBudgetExceeded": "Upplösningen överskrider renderingsbudgeten — minska DPI eller höjd",
  "forecastMaps.memoryBudgetUsage": "Renderingsbudget: {percent}%",
  "forecastMaps.metaDescription": "Animerade prognoskartor genererade från vädermodellernas körningar.",
  "forecastMaps.metric": "Mätvärde",
  "forecastMaps.metricRequired": "Välj ett mätvärde",
  "forecastMaps.metricUnavailable": "Inte tillgängligt för den här modellen",
  "forecastMaps.minBelowMax": "Min måste vara mindre än max",
  "forecastMaps.minMaxRequired": "Min- och maxvärden krävs för den här lagertypen",
  "forecastMaps.minValue": "Minvärde",
  "forecastMaps.modelNoRun": "Ingen slutförd körning ännu",
  "forecastMaps.moveLayerDown": "Flytta ned",
  "forecastMaps.moveLayerUp": "Flytta upp",
  "forecastMaps.myMaps": "Mina kartor",
  "forecastMaps.nanClipToMin": "Begränsa till min",
  "forecastMaps.nanMask": "Maskera",
  "forecastMaps.nanPolicy": "Saknade data",
  "forecastMaps.nanSkip": "Hoppa över",
  "forecastMaps.newMap": "Ny karta",
  "forecastMaps.noCompletedRun": "Den här kartan har inte genererats än. Titta tillbaka snart.",
  "forecastMaps.noLayers": "Inga lager ännu. Lägg till ett lager för att komma igång.",
  "forecastMaps.noMapsAvailable": "Inga prognoskartor är tillgängliga än.",
  "forecastMaps.north": "Nord",
  "forecastMaps.opacity": "Opacitet",
  "forecastMaps.overlayLegend": "Teckenförklaring",
  "forecastMaps.pause": "Paus",
  "forecastMaps.play": "Spela upp",
  "forecastMaps.pointValueError": "Prognosen för denna punkt kunde inte läsas in.",
  "forecastMaps.pointValueLoading": "Läser in prognos…",
  "forecastMaps.pointValueUnavailable": "Inga data för denna tidpunkt.",
  "forecastMaps.presets": "Förval",
  "forecastMaps.preview": "Förhandsvisning",
  "forecastMaps.previewEmptyHint": "Konfigurera minst ett giltigt lager för att rendera en förhandsvisning.",
  "forecastMaps.previewFailed": "Förhandsvisningen misslyckades",
  "forecastMaps.previewHour": "Prognostimme",
  "forecastMaps.previewRendering": "Renderar förhandsvisning…",
  "forecastMaps.projection": "Projektion",
  "forecastMaps.projectionLambertConformal": "Lambert konform",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografisk",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Nordamerika",
  "forecastMaps.removeColor": "Ta bort färg",
  "forecastMaps.removeLayer": "Ta bort lager",
  "forecastMaps.retry": "Försök igen",
  "forecastMaps.run": "Körning: {run}",
  "forecastMaps.save": "Spara",
  "forecastMaps.selectExtentOnMap": "Välj område på kartan",
  "forecastMaps.south": "Syd",
  "forecastMaps.title": "Prognoskartor",
  "forecastMaps.uMetric": "U-komponent",
  "forecastMaps.unitConversion": "Enhetskonvertering",
  "forecastMaps.unitNone": "Ingen",
  "forecastMaps.unsavedChangesBody": "Du har osparade ändringar. Lämna och kasta dem?",
  "forecastMaps.unsavedChangesTitle": "Osparade ändringar",
  "forecastMaps.useCurrentView": "Använd aktuell vy",
  "forecastMaps.useModelDomain": "Av: modellens hela domän används",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "U- och V-mätvärden måste vara olika",
  "forecastMaps.validTime": "Gäller: {time}",
  "forecastMaps.valueBetween": "Måste vara mellan {min} och {max}",
  "forecastMaps.variable": "Variabel",
  "forecastMaps.viewMap": "Visa karta",
  "forecastMaps.vMetric": "V-komponent",
  "forecastMaps.west": "Väst",
  "forecastMaps.windAnimation": "Vindanimation",
  "intro.locationDescription": "Aktivera platsåtkomst för att få exakta väderprognoser anpassade till ditt exakta område — inga generiska prognoser längre.",
  "intro.locationTitle": "Prognoser skapade för dig",
  "intro.notificationDescription": "Slå på aviseringar för att få snabba varningar om väderförändringar som är viktiga för dig — regn, snö eller allvarliga förhållanden, precis när du behöver veta.",
  "intro.notificationsTitle": "Missa aldrig en väderförändring",
  "intro.readyDescription": "Njut av precisa prognoser, realtidsväderinsikter och stationsdata från hela världen — allt i en kraftfull app.",
  "intro.readyTitle": "Du är redo!",
  "intro.welcomeDescription": "Få hyperlokala prognoser från toppväderbyråer — plus tillgång till över 40 000 väderstationer världen över för att se verkliga förhållanden, både historiska och aktuella.",
  "intro.welcomeTitle": "Ditt väder, omdefinierat",
  "landing.alerts": "Varningar",
  "landing.alertsDescription": "Skapa dina egna varningar och få aviseringar så snart de utlöses.",
  "landing.featureAlertsDescription": "Ställ in anpassade varningar för förhållanden som intresserar dig—temperatur, vind, nederbörd och mer.",
  "landing.featureAlertsTitle": "Smarta varningar",
  "landing.featureAnalyticsDescription": "Fördjupa dig i dina data med interaktiva diagram, jämförelser sida vid sida och trendanalyser som går bortom grundläggande mätvärden.",
  "landing.featureAnalyticsTitle": "Kraftfull analys",
  "landing.featureExportDescription": "Ladda ner dina data i CSV-format för analys i Excel, integration med andra system eller säkerhetskopiering.",
  "landing.featureExportTitle": "Exportera överallt",
  "landing.featureForecastDescription": "Jämför prognoser från över 10 vädermodeller inklusive GFS, ECMWF, ICON och fler för att se vilken som fungerar bäst för din plats.",
  "landing.featureForecastTitle": "Prognosjämförelse",
  "landing.featureHistoryDescription": "Få tillgång till historiska data med tim-, dags- och månadsskala. Exportera till CSV för forskning eller personliga arkiv.",
  "landing.featureHistoryTitle": "Rik historik",
  "landing.featureMultiBrandDescription": "Anslut stationer från Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow och fler—allt i en instrumentpanel.",
  "landing.featureMultiBrandTitle": "Stöd för flera märken",
  "landing.featuresSubtitle": "Designat för väderentusiaster som kräver mer än en grundläggande väderstationsapp.",
  "landing.featuresTitle": "Allt du behöver för att analysera väder",
  "landing.finalCtaButton": "Skapa gratis konto",
  "landing.finalCtaSubtitle": "Gå med tusentals väderentusiaster som litar på SmartMixin för sina väderdata.",
  "landing.finalCtaTitle": "Redo att förbättra din väderupplevelse?",
  "landing.forecastDescription": "Få tillgång till några av de bästa väderprognosmodellerna och jämför dem för att få din egen uppfattning om hur vädret kommer att bli.",
  "landing.forecasts": "Prognoser",
  "landing.heroCta": "Börja gratis",
  "landing.heroDescription": "Kombinera flera väderstationer från valfritt märke, jämför prognosmodeller och analysera dina data med detaljerade diagram och exporter.",
  "landing.heroSecondaryCta": "Se funktioner",
  "landing.heroTagline": "För väderentusiaster",
  "landing.heroTitle": "All väderdata. En plattform.",
  "landing.pricingFeatureAdvancedMetrics": "Avancerade mätningar",
  "landing.pricingFeatureAlerts": "Anpassade varningar",
  "landing.pricingFeatureExport": "Dataexport (CSV)",
  "landing.pricingFeatureForecastComparison": "Prognosjämförelse",
  "landing.pricingFeatureForecasts": "Prognosmodeller",
  "landing.pricingFeatureForecastsFreeTier": "1 modell",
  "landing.pricingFeatureForecastsPremiumTier": "Alla modeller (10+)",
  "landing.pricingFeatureReports": "Analyser & rapporter",
  "landing.pricingFeatureStationComparison": "Stationsjämförelse",
  "landing.pricingFeatureWidgets": "Hemskärmswidgetar",
  "landing.pricingFeatureYearOverYear": "Årsjämförelse",
  "landing.pricingFree": "Gratis",
  "landing.pricingFreeCta": "Kom igång",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Mest populär",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Kom igång",
  "landing.pricingPremiumDescription": "Från 1,99 €/månad — prenumerera på webben, App Store eller Google Play",
  "landing.pricingSubtitle": "Börja gratis, uppgradera när du behöver mer.",
  "landing.pricingTitle": "Enkel, transparent prissättning",
  "landing.smartMixinDescription": "SmartMixin är en applikation som ger tillgång till din väderstation och 40K+ andra stationer över hela världen. Det hjälper dig att se och förstå väderdata.",
  "landing.statBrands": "Stödda varumärken",
  "landing.statForecasts": "Prognosmodeller",
  "landing.statStations": "Väderstationer",
  "landing.supportedDevices": "Enheter som stöds",
  "landing.supportedDevicesDescription": "Utöver stationerna från World Meteorological Organization, stöder SmartMixin ett växande antal väderstationsmärken.",
  "landing.supportedDevicesNote": "Plus över 40 000 offentliga stationer från Världsmeteorologiska organisationen",
  "landing.supportedDevicesSubtitle": "Anslut väderstationer från ledande märken och se all data på ett ställe.",
  "landing.supportedDevicesTitle": "Fungerar med dina stationer",
  "landing.thermostatDescription": "Anslut din Netatmo-termostat för att jämföra uppvärmningsmönster med utomhusförhållanden.",
  "landing.thermostatManufacturers": "Termostattillverkare stöds också för att korrelera uppvärmning med utomhusförhållanden.",
  "landing.thermostatTitle": "Smart hem-integration",
  "landing.weatherAnalysis": "Väderanalys",
  "landing.weatherAnalysisDescription": "SmartMixin kommer med massor av datavisualisering som låter dig analysera väderdata.",
  "landing.weatherAssistant": "Din väderassistent",
  "landing.weatherAssistantDescription": "Oavsett om du är intresserad av aktuella, historiska eller prognostiserade väderförhållanden, ger SmartMixin många insikter när du behöver dem.",
  "landing.weatherForecastModels": "Väderprognosmodeller",
  "landing.weatherForecastModelsDescription": "SmartMixin ger tillgång till de mest exakta väderprognosmodellerna. Du kan enkelt jämföra deras prognoser och skapa din egen idé.",
  "landing.weatherMap": "Väderkarta",
  "landing.weatherMapDescription": "Bläddra på kartan och visualisera hur vädret är var som helst runt om i världen.",
  "network.cancelError": "Förfrågan avbruten",
  "network.connectionError": "Anslutningsfel",
  "network.networkError": "Nätverk ej tillgängligt",
  "network.serverError": "Ett problem uppstod ...",
  "network.timeoutError": "Timeout-fel",
  "network.unknownError": "Okänt fel",
  "providerHints.ambientWeatherApiKey": "Skapad i kontoinställningarna på ambientweather.net.",
  "providerHints.davisApiSecret": "Visas endast en gång när du skapade V2 API-nyckeln — förvara säkert.",
  "providerHints.davisV2ApiKey": "Från sidan med V2 API-nycklar på weatherlink.com.",
  "providerHints.ecowittApi": "Från API-sidan i ditt Ecowitt-konto.",
  "providerHints.ecowittApp": "Applikationsnyckeln, också från ditt Ecowitt-konto.",
  "providerHints.myAcuriteCredentialsBanner": "Använd e-post och lösenord till ditt My AcuRite-konto — inte SmartMixin-inloggningen.",
  "providerHints.myAcuriteEmail": "E-postadressen till ditt My AcuRite-konto — inte din SmartMixin-inloggning.",
  "providerHints.myAcuritePassword": "Lösenordet till ditt My AcuRite-konto.",
  "providerHints.weatherflowToken": "Personlig token från tempestwx.com → inställningar → dataauktoriseringar.",
  "providerHints.wundergroundEditKey": "Använd en annan nyckel",
  "providerHints.wundergroundKey": "En lång sträng från API-nyckelsidan i ditt Weather Underground-konto — inte ditt wunderground.com-lösenord.",
  "providerHints.wundergroundKeyExample": "t.ex. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-nyckel verifierad",
  "providerHints.wundergroundKeyVerifying": "Kontrollerar nyckel…",
  "providerHints.wundergroundNoStationsNearby": "Inga stationer hittades nära den här platsen. Försök att ange ett stations-ID direkt.",
  "providerHints.wundergroundStationId": "Vilket Weather Underground-stations-ID som helst — ditt eget eller en offentlig station nära dig.",
  "providerHints.wundergroundStationIdExample": "t.ex. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Hämta din Ambient Weather API-nyckel.",
  "providerIntro.davisStep2": "Hämta din Davis V2 API-nyckel och API-hemlighet.",
  "providerIntro.ecowittStep2": "Hämta din Ecowitt API-nyckel och applikationsnyckel.",
  "providerIntro.getStarted": "Kom igång",
  "providerIntro.myAcuriteStep2": "Använd e-post och lösenord till ditt befintliga My AcuRite-konto.",
  "providerIntro.netatmoEnergyStep2": "Logga in på Netatmo när du uppmanas — ingen API-nyckel behövs.",
  "providerIntro.netatmoWeatherStep2": "Logga in på Netatmo när du uppmanas — ingen API-nyckel behövs.",
  "providerIntro.signupBanner": "Nästan klart — skapa ditt kostnadsfria SmartMixin-konto för att ansluta {provider}.",
  "providerIntro.step1": "Logga in på ditt SmartMixin-konto (INTE din {provider}-inloggning).",
  "providerIntro.step3EmailPassword": "Ange dem här.",
  "providerIntro.step3KeyOrToken": "Klistra in här.",
  "providerIntro.step3OAuth": "Godkänn SmartMixin i popup-fönstret.",
  "providerIntro.step3Wunderground": "Klistra in din API-nyckel och välj sedan en station i närheten eller ange ett valfritt stations-ID.",
  "providerIntro.title": "Anslut {provider}",
  "providerIntro.weatherflowStep2": "Hämta din personliga Tempest-token.",
  "providerIntro.wundergroundBrowsePublic": "Har du ingen station? Bläddra bland offentliga",
  "providerIntro.wundergroundFindNearby": "Hitta stationer i närheten",
  "providerIntro.wundergroundOrEnterId": "Eller ange ett stations-ID",
  "providerIntro.wundergroundStep2": "Hämta din Weather Underground API-nyckel. Sedan kan du ansluta vilken station som helst — din egen eller en offentlig.",
  "reports.agroMeteorology": "Agrometeorologi",
  "reports.analysis": "Analys",
  "reports.annualCumulativeRainfallComparison": "Jämförelse av totala årliga nederbördsmängder",
  "reports.annualHeatingDurationComparison": "Årlig jämförelse av uppvärmningstid",
  "reports.annualHeatingEfficiency": "Årlig uppvärmningseffektivitet",
  "reports.annualIndoorComparison": "Årlig inomhusjämförelse",
  "reports.annualIndoorReport": "Årlig inomhusrapport",
  "reports.annualOutdoorComparison": "Årlig utomhusjämförelse",
  "reports.annualOutdoorReport": "Årsrapport utomhus",
  "reports.annualReport": "Årsrapport",
  "reports.annualSolarReport": "Årlig solrapport",
  "reports.annualWaterBalance": "Årlig vattenbalans",
  "reports.annualWaterBalanceCarryOver": "Överför föregående år",
  "reports.annualWaterBalanceDescription": "En vattenbalans (förenklad version, endast regn och evapotranspiration används) gör det möjligt att hantera vattenresursen",
  "reports.avgHumidity": "Luftfuktighet medel",
  "reports.avgMaxTemperature": "Genomsnitt T°max",
  "reports.avgMetric": "Genomsnittlig {metric}",
  "reports.avgMinTemperature": "Genomsnitt T°min",
  "reports.avgPressure": "Genomsnittligt tryck",
  "reports.avgTemperature": "Medeltemperatur",
  "reports.climateNormalPeriodOfRecord": "Mätperiod ({years} år)",
  "reports.climateNormals": "Klimatnormaler",
  "reports.climateNormalStandardLabel": "Standardnormal ({period})",
  "reports.climateTrendPerDecade": "Temperaturtrend: {value} per decennium under {years} år",
  "reports.coldestMonthRanking": "Kallaste {month} som uppmätts",
  "reports.comfortable": "Lagom (45% {lessThan} luftfuktighet ≤ 60%)",
  "reports.cumulativeRainfall": "Kumulativ nederbörd",
  "reports.cumulativeRainfallDescription": "Följ den totala nederbörden som ackumuleras under den valda perioden.",
  "reports.dailyMaxRainfall": "Daglig max nederbörd",
  "reports.dataExport": "Exportera data",
  "reports.dataExportXlsxFormatDescription": "Exportera alla stationens data i Excel-format (* .xlsx). När du klickar på knappen får du ett e-mail med bearbetade data efter några minuter.",
  "reports.daysWithFrost": "Dagar med frost",
  "reports.daysWithHeavyRain": "Dagar med kraftigt regn (≥ {threshold})",
  "reports.daysWithoutThaw": "Dagar under 0°",
  "reports.daysWithStrongFrost": "Dagar med stark frost",
  "reports.emailSent": "Ett e-mail har skickats till dig",
  "reports.frostDays": "Frostdagar",
  "reports.grasslandTemperatureSum": "Summan av gräsmarkstemperaturer",
  "reports.grasslandTemperatureSumDescription": "Hållbar återhämtning av vegetationen när summan når {threshold}",
  "reports.growingDegreeDays": "Tillväxtgraddagar",
  "reports.highPressure": "Högtryck (tryck ≥ 1013 mbar)",
  "reports.iceDays": "Isdagar",
  "reports.indoorReport": "Inomhusrapport",
  "reports.keyFacts": "Viktiga fakta",
  "reports.longestDrySpell": "Längsta torrperiod",
  "reports.longestRunOfRainyDays": "Antal på varandra följande regniga dagar",
  "reports.longestRunWithoutRun": "Antal på varandra följande dagar utan regn",
  "reports.longestWetSpell": "Längsta nederbördsperiod",
  "reports.lowPressure": "Lågtryck (tryck < 1013 mbar)",
  "reports.maxHumidity": "Luftfuktighet max",
  "reports.maxMetric": "Högsta {metric}",
  "reports.maxPressure": "Maximalt tryck",
  "reports.maxPressureMagnitude24h": "Variation max (/24H)",
  "reports.maxTemperature": "Högsta temperatur",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Variation max (/24H)",
  "reports.minHumidity": "Luftfuktighet min",
  "reports.minMetric": "Lägsta {metric}",
  "reports.minPressure": "Tryck min",
  "reports.minPressureMagnitude24h": "Variation min (/24H)",
  "reports.minTemperature": "Lägsta temperatur",
  "reports.minTempMagnitude24h": "Variation min (/24H)",
  "reports.monthlyHeatingEfficiency": "Månatlig värmeeffektivitet",
  "reports.monthlyIndoorReport": "Månadsrapport inomhus",
  "reports.monthlyOutdoorReport": "Månadsrapport utomhus",
  "reports.monthlyReport": "Månadsrapport",
  "reports.monthlySolarReport": "Månatlig solrapport",
  "reports.monthlyWindReport": "Månadsrapport vind",
  "reports.numberOfDays": "Antal dagar",
  "reports.onThisDayInHistory": "Denna dag i historien",
  "reports.outdoorReport": "utomhusrapport",
  "reports.rainfall": "Nederbörd",
  "reports.rainyDays": "Regniga dagar",
  "reports.recordDailyRain": "Regnigaste dag",
  "reports.recordHigh": "Värmerekord",
  "reports.recordLow": "Köldrekord",
  "reports.recordsAndClimatology": "Rekord och klimat",
  "reports.recordsSince": "Rekord sedan {date}",
  "reports.recordWindGust": "Kraftigaste vindby",
  "reports.relativelyWet": "Relativt fuktigt (60% {lessThan} luftfuktighet ≤ 80%)",
  "reports.sendEmail": "Skicka e-post",
  "reports.summerDays": "Sommardagar",
  "reports.tooDry": "För torr (luftfuktighet ≤ 45%)",
  "reports.tooWet": "För hög fuktighet (luftfuktighet {greaterThan} 80%)",
  "reports.tropicalNights": "Tropiska nätter",
  "reports.warmestMonthRanking": "Varmaste {month} som uppmätts",
  "reports.waterBalance": "Vattenbalans",
  "reports.yearsOfData": "{years} års data",
  "reports.yearToDateTemperature": "Hittills års temperatur",
  "reports.yearToDateTemperatureComparison": "Temperaturjämförelse från år till datum",
  "sensors.aqiByChannel": "AQI per kanal",
  "sensors.bgtSensors": "Svartkula & WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareAqi": "Jämför AQI",
  "sensors.compareHumidity": "Jämför luftfuktighet",
  "sensors.compareMoisture": "Jämför markfukt",
  "sensors.comparePm25": "Jämför PM2.5",
  "sensors.compareTemperatures": "Jämför temperaturer",
  "sensors.depthByChannel": "Djup per kanal",
  "sensors.heatStressExtreme": "Extrem värmestress",
  "sensors.heatStressModerate": "Måttlig värmestress",
  "sensors.heatStressNone": "Ingen värmestress",
  "sensors.heatStressStrong": "Stark värmestress",
  "sensors.heatStressVeryStrong": "Mycket stark värmestress",
  "sensors.humidityByChannel": "Luftfuktighet per kanal",
  "sensors.indoorAirQuality": "Inomhusluftkvalitet",
  "sensors.indoorAirQualityPm": "PM2.5 & PM10 AQI",
  "sensors.indoorClimate": "Inomhusklimat",
  "sensors.indoorCo2Levels": "CO2-nivåer",
  "sensors.indoorTemperatureAndHumidity": "Temperatur och luftfuktighet",
  "sensors.last24Hours": "24 timmar",
  "sensors.last30Days": "30 dagar",
  "sensors.last7Days": "7 dagar",
  "sensors.leafTemperatureByChannel": "Bladtemperatur per kanal",
  "sensors.leafWetnessByChannel": "Bladfuktighet per kanal",
  "sensors.lightningSensor": "Blixt",
  "sensors.moistureByChannel": "Markfukt per kanal",
  "sensors.noDataAvailable": "Ingen data tillgänglig",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 per kanal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Välj kanal",
  "sensors.sensorDetailDescription": "Visa historiska data och trender för dina sensorkanaler.",
  "sensors.sensorHistory": "Sensorhistorik",
  "sensors.soilConductivityByChannel": "Konduktivitet per kanal",
  "sensors.soilTemperatureByChannel": "Marktemperatur per kanal",
  "sensors.strikesToday": "Nedslag idag",
  "sensors.temperatureByChannel": "Temperatur per kanal",
  "sensors.viewChart": "Visa diagram",
  "settings.about": "Om",
  "settings.aboutDescription": "Licensavtal, sekretesspolicy",
  "settings.account": "Konto",
  "settings.accountDescription": "Profil, lösenordsändring",
  "settings.accountIntro": "Data gäller ditt konto:",
  "settings.accountSection": "Konto",
  "settings.appearance": "Utseende",
  "settings.appearanceDescription": "Tema och visningsalternativ",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabiska",
  "settings.availableServices": "Tillgängliga",
  "settings.bulgarian": "bulgariska",
  "settings.cannotDisconnectLastAccount": "Kan inte koppla från din enda inloggningsmetod. Lägg till en annan inloggningsmetod först.",
  "settings.catalan": "katalanska",
  "settings.changeEmail": "Ändra e-post",
  "settings.changePassword": "Byt lösenord",
  "settings.chartGestures": "Gester i diagram",
  "settings.chartGesturesDescription": "Svepning på diagram ändrar tidsperioden, nypa diagram ändrar tidsskala",
  "settings.connect": "Anslut",
  "settings.connected": "Ansluten",
  "settings.connectedAccounts": "Anslutna konton",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Anslutna",
  "settings.connectedSince": "Ansluten sedan {date}",
  "settings.connectionSuccess": "{provider}-konto anslutet",
  "settings.contactUs": "Kontakta oss",
  "settings.contactUsDescription": "Få hjälp eller skicka feedback",
  "settings.croatian": "kroatisk",
  "settings.currentPassword": "Nuvarande lösenord",
  "settings.czech": "tjeckiska",
  "settings.danish": "danska",
  "settings.dark": "Mörkt tema",
  "settings.dataDisplay": "Datavisning",
  "settings.dateAndTime": "Datum och tid",
  "settings.disconnect": "Koppla från",
  "settings.disconnectConfirmation": "Är du säker på att du vill koppla från ditt {provider}-konto?",
  "settings.disconnectionSuccess": "{provider}-konto frånkopplat",
  "settings.donateButton": "Ge en donation",
  "settings.donateDescription": "SmartMixin är byggd av ett litet team. Om du har nytta av den kan du stödja utvecklingen med en engångsdonation på valfritt belopp. Det är en gåva — den ändrar inte ditt abonnemang och låser inte upp några funktioner.",
  "settings.donateSuccessBody": "Din donation hjälper till att hålla SmartMixin igång och göra den bättre. Vi uppskattar det verkligen.",
  "settings.donateSuccessTitle": "Tack för ditt stöd!",
  "settings.donateTitle": "Stöd SmartMixin",
  "settings.dutch": "nederländska",
  "settings.emailChange": "Ändra e-postadress",
  "settings.emailChangeConfirmation": "Bekräftelse av e-poständring",
  "settings.emailChangeFailure": "Länken för e-poständring är ogiltig eller har gått ut.",
  "settings.emailChangeSuccess": "Din e-post har ändrats till {newEmail}.",
  "settings.emailChangeVerificationSent": "Ett verifieringsmeddelande har skickats till din nya e-postadress. Kontrollera din inkorg och klicka på länken för att bekräfta ändringen.",
  "settings.english": "engelska",
  "settings.forecastModelOrderEmpty": "Ingen ordning sparad — vi använder GFS som standard.",
  "settings.forecastModelOrderFreeHint": "Premium-modeller kräver en SmartMixin Premium-prenumeration.",
  "settings.forecastModelOrderHelp": "Vi väljer den första modellen i listan som täcker varje station.",
  "settings.forecastModelOrderReset": "Återställ",
  "settings.forecastModelOrderTitle": "Standardprognosmodell",
  "settings.forecastModels": "Prognosmodeller",
  "settings.forecastModelsDescription": "Sortera efter preferens",
  "settings.french": "franska",
  "settings.german": "tyska",
  "settings.gestures": "Gester",
  "settings.greek": "grekisk",
  "settings.helpCenter": "Hjälpcenter",
  "settings.helpCenterDescription": "Vanliga frågor och guider",
  "settings.hungarian": "ungerska",
  "settings.integrationsSection": "Integrationer",
  "settings.italian": "italienska",
  "settings.japanese": "japanska",
  "settings.korean": "koreanska",
  "settings.language": "Språk",
  "settings.languageDescription": "Föredraget språk",
  "settings.light": "Ljust tema",
  "settings.newEmailAddress": "Ny e-postadress",
  "settings.newPassword": "Nytt lösenord",
  "settings.newPasswordAgain": "Nytt lösenord (igen)",
  "settings.norwegian": "norska",
  "settings.notConnected": "Inte ansluten",
  "settings.notificationsSection": "Aviseringar",
  "settings.oldPassword": "Gammalt lösenord",
  "settings.ongoingNotificationEnabled": "Aktivera permanent avisering",
  "settings.ongoingNotificationMetrics": "Visade mätvärden",
  "settings.ongoingNotificationMetricsHint": "Dra för att ändra ordning på valda mätvärden",
  "settings.ongoingNotificationPermissionRequired": "Aviseringsbehörighet krävs",
  "settings.ongoingNotificationStation": "Väderstation",
  "settings.passwordChange": "Lösenordsbyte",
  "settings.polish": "polska",
  "settings.portuguese": "portugisiska",
  "settings.preferencesSection": "Inställningar",
  "settings.premium": "Premium",
  "settings.premiumActive": "Aktiv",
  "settings.premiumAnnualThenPrice": "Sedan 9,99 €/år",
  "settings.premiumAnnualTrialInfo": "Börja med en gratis provperiod på {days} dagar",
  "settings.premiumCurrentPlan": "Nuvarande abonnemang",
  "settings.premiumDescription": "Lås upp premiumfunktioner",
  "settings.premiumDownloadApp": "Ladda ner appen för att prenumerera:",
  "settings.premiumExpiresOn": "Förnyas {date}",
  "settings.premiumFreePlan": "Gratis",
  "settings.premiumInactive": "Inte prenumerant",
  "settings.premiumManageWebSubscription": "Hantera din prenumeration, uppdatera betalningsmetod eller avsluta.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Årsvis — 9,99 €/år",
  "settings.premiumSubscribedOn": "Prenumererad på {platform}",
  "settings.premiumSubscribeMonthly": "Månadsvis — 1,99 €/månad",
  "settings.premiumSubscribeOnWeb": "Prenumerera nu för att låsa upp alla premiumfunktioner.",
  "settings.premiumSubscriptionSuccess": "Din prenumeration har aktiverats! Njut av alla premiumfunktioner.",
  "settings.premiumSubscriptionSuccessTitle": "Välkommen till Premium!",
  "settings.premiumWebappNotice": "Prenumerationer kan endast köpas via SmartMixin-mobilappen på iOS eller Android.",
  "settings.privacyPolicy": "Sekretesspolicy",
  "settings.profile": "Profil",
  "settings.russian": "ryska",
  "settings.serbian": "serbiska",
  "settings.settings": "Konfiguration",
  "settings.slovak": "slovakiska",
  "settings.smallDecimals": "Små decimaler",
  "settings.smallDecimalsDescription": "Visa decimalsiffror i en mindre storlek",
  "settings.socialConnectionsIntro": "Länka dina sociala konton för snabb inloggning. Du kan ansluta eller koppla från konton när som helst.",
  "settings.spanish": "spanska",
  "settings.statusBarWidget": "Statusfältswidget",
  "settings.statusBarWidgetDescription": "Alltid synliga väderdata",
  "settings.subscriptionSection": "Prenumeration",
  "settings.supportSection": "Support",
  "settings.swedish": "svenska",
  "settings.systemTheme": "Systemtema",
  "settings.termsOfService": "Användarvillkor",
  "settings.turkish": "turkisk",
  "settings.ukrainian": "ukrainska",
  "settings.units": "Enheter",
  "settings.unitsDescription": "Måttenheter som visas i appen",
  "settings.update": "Uppdatera",
  "settings.updateYourProfile": "Uppdatera din profil",
  "settings.weatherServices": "Vädertjänster",
  "settings.weatherServicesConnected": "{count, plural, =0 {Inga tjänster anslutna} one {# tjänst ansluten} other {# tjänster anslutna}}",
  "settings.weatherServicesDescription": "Anslut Netatmo, Davis, Weatherflow och fler",
  "settings.windDirectionConvention": "Vindriktningspil",
  "settings.windDirectionConventionDescription": "Välj hur vindriktningspilar visas",
  "settings.windDirectionMeteorological": "Ursprungsriktning",
  "settings.windDirectionMeteorologicalDescription": "Pilen visar varifrån vinden kommer (meteorological konvention)",
  "settings.windDirectionOceanographic": "Strömningsriktning",
  "settings.windDirectionOceanographicDescription": "Pilen visar vart vinden blåser (oceanographic konvention)",
  "units.absolutePressure": "Absolut tryck",
  "units.airDensity": "Luftdensitet",
  "units.airGap": "Luftspalt",
  "units.apparentTemperature": "Upplevd temperatur",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Genomsnitt",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Svartkuletemperatur",
  "units.boilerOn": "Värme på",
  "units.co2": "CO2",
  "units.conductivity": "Konduktivitet",
  "units.coolingDegreeDays": "Dagar med nedkylning",
  "units.dailyHeatingDuration": "Daglig uppvärmningstid",
  "units.dailyPrecipitation": "Dygnsnederbörd",
  "units.dailyRain": "Daglig nederbörd",
  "units.degreeDay": "Graddagar",
  "units.degreeDayShort": "GD",
  "units.depth": "Djup",
  "units.depthSensors": "Djupsensorer",
  "units.dewPoint": "Daggpunkt",
  "units.distance": "Distans",
  "units.downTrend": "Nedåtgående trend",
  "units.E": "E",
  "units.E_long": "Öst",
  "units.ENE": "ENE",
  "units.ENE_long": "öst-nordost",
  "units.ESE": "ESE",
  "units.ESE_long": "öst-sydost",
  "units.ET": "Evapotranspiration",
  "units.ETshort": "ET",
  "units.feelLike": "Känns som",
  "units.feelsLike": "Känns som",
  "units.footMile": "fot, mil",
  "units.frostPoint": "frostpunkt",
  "units.gust": "Vindbyar",
  "units.heatIndex": "Värmeindex",
  "units.heatingDegreeDays": "Dagar med uppvärmning",
  "units.heatingPower": "Värmekraft",
  "units.humidex": "Fuktindex",
  "units.humidity": "Luftfuktighet",
  "units.inch": "Tum",
  "units.inchOfMercury": "Kvicksilver per tum",
  "units.kilometerPerHour": "Kilometer per timme",
  "units.knot": "Knop",
  "units.last12Hours": "Senaste 12 timmarna",
  "units.last24Hours": "Senaste 24 timmarna",
  "units.last3Hours": "Senaste 3 timmarna",
  "units.last6Hours": "Senaste 6 timmarna",
  "units.lastHour": "Senaste timmen",
  "units.lastLightningImpact": "Sista blixtnedslaget",
  "units.lastMeasure": "Senaste åtgärd",
  "units.leafSensors": "Bladsensorer",
  "units.leafWetness": "Bladvåthet",
  "units.lightningDistance": "Distans",
  "units.lightningStrikeCount": "Antalet blixtnedslag",
  "units.lightningStrikeDistance": "Blixtnedslagsavstånd",
  "units.max": "Max.",
  "units.max_gust": "Max. vindbyar",
  "units.max_wind": "Max. vindstyrka",
  "units.meterKilometer": "meter, kilometer",
  "units.meterPerSecond": "Meter per sekund",
  "units.milePerHour": "Miles per timme",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimeter",
  "units.millimeterOfMercury": "Millimeter kvicksilver",
  "units.min": "Min.",
  "units.N": "N",
  "units.N_long": "norr",
  "units.NE": "NE",
  "units.NE_long": "nordost",
  "units.NNE": "NNE",
  "units.NNE_long": "nordnordost",
  "units.NNW": "NNW",
  "units.NNW_long": "nord-nordväst",
  "units.noise": "Ljudnivå",
  "units.normalizedHeatingCoefficient": "Normaliserad värmekoeffecient",
  "units.NW": "NW",
  "units.NW_long": "nordväst",
  "units.O3": "Ozon",
  "units.PM_1": "PM 1",
  "units.PM_10": "PM 10",
  "units.PM_2P5": "PM 2,5",
  "units.precipitation": "Nederbörd",
  "units.pressure": "Lufttryck",
  "units.rain": "Nederbörd",
  "units.rainRate": "Regnintensitet",
  "units.referenceTemperature": "Referenstemperatur",
  "units.relativePressure": "Relativt tryck",
  "units.S": "S",
  "units.S_long": "söder",
  "units.SE": "SE",
  "units.SE_long": "Sydöstra",
  "units.setPoint": "Börvärde",
  "units.snow": "Snö",
  "units.snowfall": "Snöfall",
  "units.soilMoisture": "Markfuktighet",
  "units.soilSensors": "Marksensorer",
  "units.solarEnergy": "Solenergi",
  "units.solarRadiation": "Solstrålning",
  "units.speed": "Hastighet",
  "units.SSE": "SSE",
  "units.SSE_long": "syd-sydost",
  "units.SSW": "SSW",
  "units.SSW_long": "syd-sydväst",
  "units.stableTrend": "Stabil trend",
  "units.sum": "Summa",
  "units.SW": "SW",
  "units.SW_long": "Sydväst",
  "units.temperature": "Temperatur",
  "units.temperatureAndHumiditySensors": "Temperatur/fuktighetsgivare",
  "units.temperatureSensors": "Temperatur/fuktighetsgivare",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Idag",
  "units.upTrend": "Upptrend",
  "units.uv": "UV",
  "units.visibility": "Synlighet",
  "units.W": "W",
  "units.W_long": "västerut",
  "units.wetBulbGlobeTemperature": "Våtkuletemperatur",
  "units.wetBulbTemperature": "Våt kultemperatur",
  "units.wind": "Vind",
  "units.windChill": "Vindens kyleffekt",
  "units.windDirection": "Vindriktning",
  "units.windRun": "vindens gång",
  "units.windRunDescription": "Vindfärd är den totala sträckan som vinden tillryggalagt under en tidsperiod",
  "units.WNW": "WNW",
  "units.WNW_long": "väst-nordväst",
  "units.WSW": "WSW",
  "units.WSW_long": "väst-sydväst"
}
